import { useTranslation } from 'react-i18next';
import { FadeInSection } from '@/components/ui/FadeInSection';

const STORAGE_BASE = `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/partners-logos`;

const partners = [
  { name: 'Chaire AgroTIC',              label: 'Chaire de recherche',      logo: 'agrotic.png' },
  { name: 'Alliance Harvest',            label: 'Chaire de recherche',      logo: 'alliance-harvest.svg' },
  { name: 'INRAE',                       label: 'Institut de recherche',    logo: 'inrae.svg' },
  { name: "Chambres d'Agriculture",      label: 'Réseau national',          logo: 'chambres-agriculture.webp' },
  { name: 'Maisadour',                   label: 'Coopérative agricole',     logo: 'maisadour.png' },
  { name: 'BIVB',                        label: 'Vins de Bourgogne',        logo: 'bivb.svg' },
  { name: 'The Shift Project',           label: 'Think tank',               logo: 'shift-project.svg' },
  { name: 'Management des Risques',      label: 'Chaire de recherche',      logo: 'management-risques.jpg' },
  { name: 'Château Lafite',             label: 'Domaine viticole',         logo: 'chateau-lafite.png' },
  { name: 'Pellenc',                     label: 'Matériel agricole',        logo: 'pellenc.png' },
  { name: 'Binaree',                     label: 'Transformation digitale',  logo: 'binaree.webp' },
  { name: 'Smag',                        label: 'Logiciels agricoles',      logo: 'smag.svg' },
  { name: 'Agri Sud-Ouest Innovation',   label: 'Pôle de compétitivité',    logo: 'agri-sud-ouest.png' },
  { name: 'Wiki AgriTech',               label: 'Média agritech',           logo: 'wiki-agritech.svg' },
];

// Tripliquer pour un défilement vraiment continu sans saut visible
const items = [...partners, ...partners, ...partners];

function PartnerCard({ name, label, logo }: { name: string; label: string; logo: string }) {
  return (
    <div className="flex-shrink-0 flex flex-col items-center justify-center bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow w-44 h-28 px-4 py-3 mx-3">
      <img
        src={`${STORAGE_BASE}/${logo}`}
        alt={`Logo ${name}`}
        className="max-h-10 max-w-[120px] w-auto object-contain mb-2"
        loading="lazy"
        onError={(e) => {
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
      <span className="text-xs font-semibold text-aspexit-black text-center leading-tight line-clamp-2">
        {name}
      </span>
      <span className="text-[10px] text-aspexit-gray/60 mt-0.5 text-center">
        {label}
      </span>
    </div>
  );
}

export function TrustedByBanner() {
  const { t } = useTranslation('home');

  return (
    <section className="py-12 bg-aspexit-gray-light">
      {/* Titre — même style que "Dernières Analyses" */}
      <FadeInSection>
        <div className="text-center mb-10 container mx-auto px-4 max-w-7xl">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-aspexit-black">
            {t('trustedBy.title')}
          </h2>
          <p className="text-aspexit-gray mt-3 text-base max-w-xl mx-auto">
            {t('trustedBy.subtitle')}
          </p>
        </div>
      </FadeInSection>

      {/* Piste défilante — overflow caché sur ce wrapper */}
      <div className="overflow-hidden relative">
        {/* Dégradés sur les bords */}
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-aspexit-gray-light to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-aspexit-gray-light to-transparent z-10 pointer-events-none" />

        {/* Bandeau animé — pause au survol */}
        <div className="flex animate-marquee" style={{ width: 'max-content' }}>
          {items.map((p, i) => (
            <PartnerCard key={i} {...p} />
          ))}
        </div>
      </div>
    </section>
  );
}
